import React from "react";

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar__text">
        <div className="logo">
          <img src="/img/logo.png" alt="logo" />
        </div>
        <ul className="navbar__ul">
          <li>
            <a href="">Home</a>
          </li>
          <li>
            <a href="Menu.js">Menu</a>
          </li>
          <li>
            <a href="Shop">Shop</a>
          </li>
          <li>
            <a href="Prices.js">Prices</a>
          </li>
          <li>
            <a href="About.js">About</a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
